import module from 'fan/proyecto/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class FanProyectoDocumentosPlantillaGenerarComponent {
  idProyecto
  idPlantilla
  version
  config = {}
  contenido = ''
  etiquetas = []
  etiquetasRequeridas = []
  recopilando = false

  constructor ($q, $state, FanProyectoDocumentosPlantillaConfiguracionService, FanProyectoDocumentosPlantillaContenidoService, FanProyectoDocumentosPlantillasConfiguracionEtiquetasService) {
    this.$q = $q
    this.$state = $state
    this.FanProyectoDocumentosPlantillaConfiguracionService = FanProyectoDocumentosPlantillaConfiguracionService
    this.FanProyectoDocumentosPlantillaContenidoService = FanProyectoDocumentosPlantillaContenidoService
    this.FanProyectoDocumentosPlantillasConfiguracionEtiquetasService = FanProyectoDocumentosPlantillasConfiguracionEtiquetasService
    this.idProyecto = undefined
    this.idPlantilla = undefined
    this.nombre = null
    this.version = undefined
    this.seleccionados = []
  }

  $onInit () {
    this.promise = this.$q.all([
        this.FanProyectoDocumentosPlantillaConfiguracionService.get(this.idProyecto, this.idPlantilla, this.version)
          .then((response) => {
            this.data = orderBy(response.data.contenido, ['descripcion'])
            this.data.forEach((item) => (item.seleccionado = false))
            this.nombre = response.data.nombre
          }),
        this.FanProyectoDocumentosPlantillaContenidoService.get(this.idProyecto, this.idPlantilla, this.version)
          .then(({data}) => (this.contenido = data.documento_contenido)),
        this.FanProyectoDocumentosPlantillasConfiguracionEtiquetasService.get(this.idProyecto, this.idPlantilla)
          .then(({data}) => (this.etiquetas = data)),
      ])
      .then(() => (this.buscarEtiquetasRequeridas()))
  }

  buscarEtiquetasRequeridas () {
    if (!this.contenido || this.recopilando) return

    this.etiquetasRequeridas = this.etiquetas.filter((etiqueta) => (etiqueta.dinamica && this.contenido.includes('[[' + etiqueta.nombre)))
  }

  recalcular () {
    this.seleccionados = this.data.filter((item) => item.seleccionado)
  }

  cerrar (data) {
    this.generando = false
    if (data)
      this.data = data

    let completado = this.data.every((item) => item.documento)

    if (completado) {
      this.$state.go('proyecto.documentos.plantillas')
    } else {
      this.data.forEach((item) => (item.seleccionado = item.seleccionado && !item.documento))
      this.data = [...this.data]
      this.recalcular()
    }
  }
}

module.component('fanProyectoDocumentosPlantillaGenerar', {
  controller: FanProyectoDocumentosPlantillaGenerarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    idPlantilla: '<',
    version: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantilla/generar/component.js